import { BRAND_SECONDARY } from "../../../utils/Styles";
import * as React from "react";
import {
  IDropdownOption,
  DefaultButton,
  Stack,
  PrimaryButton,
  DayOfWeek,
  DatePicker,
  Dropdown,
  Text,
  Checkbox,
  TooltipHost,
  DropdownMenuItemType,
  ISelectableOption,
  Breadcrumb,
  Callout,
  DirectionalHint,
} from "office-ui-fabric-react";
import {
  IDataCenter,
  ISearchIdc,
  IIDCReading,
  IReadingStatus,
  IFloorVM,
} from "../../../vm";
import {
  getFloorsWhichHasUnits,
  getADataCenter,
} from "../../../services/datacenter/DatacenterService";
import { ToastContext } from "../../common/ToastProvider";
import { ConfirmDialogContext } from "../../common/ConfirmDialogProvider";
import { useParams, useHistory } from "react-router-dom";
import {
  getIdcReadings,
  updateIdcReadingStatus,
} from "../../../services/infrastructure/IdcTemperatureService";
import moment from "moment";
import NoDataTile from "../../common/NoDataTile";
import {
  childrenGap,
  ALL_SHIFT,
  UPS_STATUS,
  READ_AT_TIME_FORMAT,
  childrenGap8,
  EVEN_SHIFT,
} from "../../common/Constants";
import { Loading } from "../../../services/Loading";
import Icon from "@mdi/react";
import {
  mdiCheck,
  mdiChevronLeft,
  mdiChevronRight,
  mdiClose,
  mdiDotsVertical,
  mdiPencil,
} from "@mdi/js";
import {
  getThreshold,
  isInThreshold,
  isValueLessThanThreshold,
} from "../../../services/ThresholdService";
import ManageIdcTemperatureDialog from "./ManageIdcTemperatureDialog";
import ManageAllRejectDialog from "../../common/ManageAllRejectDialog";
import ShowThresholdIcon from "../../common/ShowThresholdIcon";

export interface IdcTemperatureMainProps { }

const IdcTemperatureMain: React.FC<IdcTemperatureMainProps> = () => {
  //state
  const [state, setState] = React.useState({
    isLoading: false,
    isDatacenterFound: false,
    isIdcLoaded: false,
    upsList: [],
    allFloorsDropdownList: [],
    datacenter: undefined,
    searchObj: { datacenterId: "", date: new Date(), floorId: "" },
    idcReading: [],
    isIndeterminate: false,
    isAllChecked: false,
    selectedItems: [],
    length: 0,
    tempArray: [],
    threshold: undefined,
    manageIdcDialog: {
      isOpen: false,
      index: undefined,
      data: undefined,
    },
    manageRejectDialog: {
      isOpen: false,
      ids: [],
      remarks: "",
    },
    manageActionsCallout: {
      isOpen: false,
      element: undefined,
      data: undefined,
    },
  } as {
    isLoading: boolean;
    isDatacenterFound: boolean;
    isIdcLoaded: boolean;
    allFloorsDropdownList: IDropdownOption[];
    datacenter?: IDataCenter;
    searchObj: ISearchIdc;
    idcReading: IIDCReading[];
    isIndeterminate: boolean;
    isAllChecked: boolean;
    selectedItems: string[];
    length: number;
    tempArray: number[];
    threshold: any;
    manageIdcDialog: {
      isOpen: boolean;
      index?: number;
      data?: IIDCReading;
    };
    manageRejectDialog: {
      isOpen: boolean;
      ids: string[];
      remarks?: string;
    };
    manageActionsCallout: {
      isOpen: boolean;
      element: any;
      data?: IIDCReading;
    };
  });

  //hooks
  const { showToast } = React.useContext(ToastContext);
  const { showConfirmDialog } = React.useContext(ConfirmDialogContext);
  const params: any = useParams();
  const history: any = useHistory();

  React.useEffect(() => {
    const asyncFunc = async () => {
      if (params.dataCenterId) {
        getDatacenter(params.dataCenterId);
      }
    };
    asyncFunc();
  }, []);

  const getDatacenter = async (datacenterId: string) => {
    setState({ ...state, isLoading: true });
    let result = await getADataCenter(datacenterId);
    if (result?.success) {
      console.log("datacenter", result.data);
      setState({
        ...state,
        datacenter: result.data,
        isDatacenterFound: true,
        isLoading: false,
      });

      getThresholdData(result.data);
    } else {
      showToast(result?.message || "Error while getting datacenter", "error");
      setState({ ...state, isDatacenterFound: false, isLoading: false });
    }
  };

  const getThresholdData = async (datacenter: IDataCenter) => {
    setState({ ...state, isLoading: true });
    let result = await getThreshold("idc");
    if (result?.success) {
      getFloorList(datacenter, result.data.threshold);
    } else {
      showToast(result?.message || "Error while getting datacenter", "error");
      setState({ ...state, isDatacenterFound: false, isLoading: false });
    }
  };

  const getFloorList = async (datacenter: IDataCenter, threshold: any) => {
    setState({ ...state, isLoading: true });
    // let result = await getFloorsWhichHasUnits({
    //   dataCenterId: params.dataCenterId,
    //   type: "ups",
    // });
    // if (result?.success) {
    let buildings = datacenter.buildings;
    let floors = datacenter.floors;

    let result = floors.map((ele) => {
      let b = buildings.find((a) => a._id === ele.buildingId);
      return {
        buildingId: ele.buildingId,
        floorId: ele._id,
        floorName: ele.name,
        buildingName: b.name,
      };
    });

    let options: IDropdownOption[] = [];

    const floorByBuilding: { [Key: string]: IFloorVM[] } = result.reduce(
      (acc: any, d) => {
        if (acc[d.buildingId] == null) {
          acc[d.buildingId] = [];
        }

        acc[d.buildingId].push(d);
        return acc;
      },
      {}
    );
    let temp = Object.keys(floorByBuilding);
    temp.forEach((d, index) => {
      options.push({
        key: d,
        text: floorByBuilding[d][0].buildingName,
        itemType: DropdownMenuItemType.Header,
      });
      floorByBuilding[d].forEach((f) => {
        options.push({
          key: f.floorId,
          text: f.floorName,
          data: { buildingName: f.buildingName },
        });
      });
      if (temp.length != index + 1) {
        options.push({
          key: "divider_1",
          text: "-",
          itemType: DropdownMenuItemType.Divider,
        });
      }
    });

    // result.forEach((ele: any) => {
    //   options.push({
    //     key: ele.floorId,
    //     text: `${ele.buildingName} - ${ele.floorName}`,
    //   });
    // });
    let obj = {
      ...state,
      isLoading: false,
      datacenter,
      isDatacenterFound: true,
      allFloorsDropdownList: options,
      searchObj: {
        datacenterId: params.dataCenterId,
        date: new Date(),
        floorId: options.length > 1 ? (options[1].key as string) : "",
      },
      threshold,
    };
    setState(obj);
    getIdcReadingsData(obj);
  };

  const getIdcReadingsData = async (paramState?: any) => {
    let localState = { ...state };
    if (paramState != null) {
      localState = { ...paramState };
    }

    setState({ ...localState, isLoading: true });
    let obj = { ...localState.searchObj };
    obj.date = moment(obj.date).format("YYYY-MM-DD");
    let result = await getIdcReadings(obj);
    if (result?.success) {
      let lengthArray: number[] = [];
      let tempArray: number[] = [];
      if (result.data?.length > 0) {
        result.data.forEach((ele) => lengthArray.push(ele.readings.length));
      }
      if (lengthArray.length > 0) {
        for (let index = 0; index < Math.max(...lengthArray); index++) {
          tempArray.push(index);
        }
      }
      setState({
        ...localState,
        idcReading: result.data,
        isLoading: false,
        isIdcLoaded: true,
        length: lengthArray.length > 0 ? Math.max(...lengthArray) : 0,
        tempArray,
      });
    } else {
      showToast(result?.message || "Error while getting idc readings", "error");
      setState({ ...state, isLoading: false, isIdcLoaded: false });
    }
  };

  const onSearch = async () => {
    if (!state.searchObj.floorId) {
      showToast("Please select a floor before searching", "error");
      return;
    }
    getIdcReadingsData();
  };

  const handleOpenDialog = (isOpen: boolean, id?: string) => {
    let idcReadingItem = undefined;
    let index = undefined;
    if (id !== undefined) {
      let idcReadingList = [...state.idcReading];
      index = idcReadingList.findIndex((e) => e._id === id);
      idcReadingItem = { ...state.idcReading[index] };
    }
    setState({
      ...state,
      manageIdcDialog: {
        isOpen: isOpen,
        index: index,
        data: idcReadingItem,
      },
    });
  };

  const handleCloseDialog = (data: IIDCReading) => {
    let idcReading = [...state.idcReading];
    if (data) {
      if (state.manageIdcDialog.index !== undefined) {
        idcReading[state.manageIdcDialog.index] = data;
      }
    }
    setState({
      ...state,
      manageIdcDialog: {
        isOpen: false,
        index: undefined,
        data: undefined,
      },
      idcReading,
    });
  };

  const handleRejectAllOpenDialog = (ids: string[]) => {
    setState({
      ...state,
      manageRejectDialog: {
        isOpen: true,
        ids: ids || [],
        remarks: "",
      },
    });
  };
  const handleRejectOpenDialog = (id: string, remarks?: string) => {
    setState({
      ...state,
      manageRejectDialog: {
        isOpen: true,
        ids: [id],
        remarks: remarks || "",
      },
    });
  };

  const handleRejectCloseDialog = async (
    isSuccess: boolean,
    remarks?: string
  ) => {
    let idcReading = [...state.idcReading];
    let selectedItems: string[] = state.manageRejectDialog.ids;
    if (isSuccess) {
      setState({
        ...state,
        isLoading: true,
      });
      let obj: IReadingStatus = {
        ids: selectedItems,
        status: "rejected",
        remarks: remarks || "",
      };
      let result = await updateIdcReadingStatus(obj);
      if (result?.success) {
        selectedItems.forEach((item) => {
          let index = idcReading.findIndex((ele) => ele._id === item);
          if (index !== -1) {
            idcReading[index].status = "rejected";
            idcReading[index].remarks = remarks || "";
          }
        });
        showToast(`IDC Reading rejected successfully`, "success");
        setState({
          ...state,
          idcReading,
          selectedItems: [],
          manageRejectDialog: {
            isOpen: false,
            ids: [],
            remarks: undefined,
          },
          isLoading: false,
        });
      } else {
        showToast(
          result?.message || `An error occurred while rejecting a idc reading`,
          "error"
        );
        setState({
          ...state,
          manageRejectDialog: {
            isOpen: false,
            ids: [],
            remarks: undefined,
          },
          isLoading: false,
        });
      }
    } else {
      setState({
        ...state,
        manageRejectDialog: {
          isOpen: false,
          ids: [],
          remarks: undefined,
        },
        idcReading,
      });
    }
  };

  const handleLoading = () => {
    setState({
      ...state,
      isLoading: !state.isLoading,
    });
  };

  const handleAcceptOrReject = (id: string, isAccept: boolean) => {
    showConfirmDialog(
      "Are You Sure",
      `Do you want to ${isAccept ? "Accept" : "Reject"} the idc reading`,
      async () => {
        setState({
          ...state,
          isLoading: true,
          manageActionsCallout: {
            isOpen: false,
            element: undefined,
            data: undefined,
          },
        });
        let obj: IReadingStatus = {
          ids: [id],
          status: isAccept ? "approved" : "rejected",
        };
        let result = await updateIdcReadingStatus(obj);
        if (result?.success) {
          let idcReading = [...state.idcReading];
          let index = idcReading.findIndex((ele) => ele._id === id);
          if (index !== -1) {
            idcReading[index].status = isAccept ? "approved" : "rejected";
          }
          let selectedItems = [...state.selectedItems];
          let indexToRemove = selectedItems.findIndex((ele) => ele === id);
          if (index !== -1) {
            selectedItems.splice(indexToRemove, 1);
          }
          showToast(
            `IDC Reading ${isAccept ? "approved" : "rejected"} successfully`,
            "success"
          );
          setState({
            ...state,
            idcReading,
            selectedItems,
            isLoading: false,
            manageActionsCallout: {
              isOpen: false,
              element: undefined,
              data: undefined,
            },
          });
        } else {
          showToast(
            result?.message ||
            `An error occurred while ${isAccept ? "approving" : "rejecting"
            } a idc reading`,
            "error"
          );
          setState({
            ...state,
            isLoading: false,
            manageActionsCallout: {
              isOpen: false,
              element: undefined,
              data: undefined,
            },
          });
        }
      }
    );
  };

  const handleAcceptOrRejectSelected = (isAccept: boolean) => {
    if (isAccept) {
      showConfirmDialog(
        "Are You Sure",
        `Do you want to ${isAccept ? "Accept" : "Reject"} selected idc reading`,
        async () => {
          let selectedItems = [...state.selectedItems];
          let idcReading = [...state.idcReading];
          setState({
            ...state,
            isLoading: true,
          });
          let obj: IReadingStatus = {
            ids: selectedItems,
            status: isAccept ? "approved" : "rejected",
          };
          let result = await updateIdcReadingStatus(obj);
          if (result?.success) {
            selectedItems.forEach((item) => {
              let index = idcReading.findIndex((ele) => ele._id === item);
              if (index !== -1) {
                idcReading[index].status = isAccept ? "approved" : "rejected";
              }
            });
            showToast(
              `IDC Reading ${isAccept ? "approved" : "rejected"} successfully`,
              "success"
            );
            setState({
              ...state,
              idcReading,
              selectedItems: [],
              isLoading: false,
            });
          } else {
            showToast(
              result?.message ||
              `An error occurred while ${isAccept ? "approving" : "rejecting"
              } a idc reading`,
              "error"
            );
            setState({
              ...state,
              isLoading: false,
            });
          }
        }
      );
    } else {
      let selectedItems = [...state.selectedItems];
      handleRejectAllOpenDialog(selectedItems);
    }
  };

  const onSelectAll = (isAllChecked: boolean) => {
    let selectedItems: string[] = [];
    if (isAllChecked) {
      state.idcReading.forEach((ele) => {
        if (ele.status === "submitted") {
          selectedItems.push(ele._id as string);
        }
      });
      setState({ ...state, isAllChecked: true, selectedItems });
    } else {
      setState({ ...state, isAllChecked: false, selectedItems });
    }
  };

  const onIndividualSelect = (id: string) => {
    let selectedItems = [...state.selectedItems];
    let index = selectedItems.findIndex((e) => e === id);
    if (index === -1) {
      selectedItems.push(id);
    } else {
      selectedItems.splice(index, 1);
    }
    let isAllChecked = true;
    state.idcReading.forEach((ele) => {
      if (
        ele.status === "submitted" &&
        selectedItems.includes(ele._id as string) === false
      ) {
        isAllChecked = false;
      }
    });
    setState({ ...state, selectedItems, isAllChecked });
  };

  const getMinValue = (property: string, index: number) => {
    if (state.idcReading.length > 0) {
      let list = state.idcReading.map((ele: any) => {
        if (ele.readings[index]) {
          return ele.readings[index][property];
        } else {
          return 0;
        }
      });
      return Math.min(...list);
    } else {
      return "";
    }
  };
  const getMaxValue = (property: string, index: number) => {
    if (state.idcReading.length > 0) {
      let list = state.idcReading.map((ele: any) => {
        if (ele.readings[index]) {
          return ele.readings[index][property];
        } else {
          return 0;
        }
      });
      return Math.max(...list);
    } else {
      return "";
    }
  };

  const onNextOrPrevFunc = (isPrev: boolean) => {
    let localState = { ...state };

    let currentSelectedFloor = localState.searchObj.floorId;
    let currentFloorList = localState.allFloorsDropdownList;

    if (isPrev) {
      let currentFloorIndex = currentFloorList.findIndex(
        (d) => d.key === currentSelectedFloor
      );
      if (currentFloorIndex === 1) return;
      let currentFloor = currentFloorList[currentFloorIndex - 1];
      if (currentFloor.itemType) {
        // this is due to divider and header
        currentFloor = currentFloorList[currentFloorIndex - 3];
      }
      currentSelectedFloor = currentFloor.key as string;

      localState = {
        ...localState,
        searchObj: {
          ...localState.searchObj,
          floorId: currentSelectedFloor,
        },
      };
    } else {
      let currentFloorIndex = currentFloorList.findIndex(
        (d) => d.key === currentSelectedFloor
      );
      if (currentFloorIndex === currentFloorList.length - 1) return;
      let currentFloor = currentFloorList[currentFloorIndex + 1];
      if (currentFloor.itemType) {
        // this is due to divider and header
        currentFloor = currentFloorList[currentFloorIndex + 3];
      }
      currentSelectedFloor = currentFloor.key as string;

      localState = {
        ...localState,
        searchObj: {
          ...localState.searchObj,
          floorId: currentSelectedFloor,
        },
      };
    }

    console.log("[onNextOrPrevFunc localState]", localState);
    getIdcReadingsData(localState);
  };

  const onRenderOption = (option?: ISelectableOption): JSX.Element => {
    if (!option) return <div />;
    return (
      <div className="d-flex">
        {/* {!option.itemType && <Icon path={mdiFloorPlan} size={0.8} />} */}
        <span style={{ marginLeft: option.itemType ? "0px" : "12px" }}>
          {option.text}
        </span>
      </div>
    );
  };

  const onRenderTitle = (options?: IDropdownOption[]): JSX.Element => {
    if (!options) return <div />;
    const option = options[0];

    return (
      <div>
        <span>{option.data.buildingName + "-" + option.text}</span>
      </div>
    );
  };

  const handleCallOutOpenClose = (
    isOpen: boolean,
    ele?: React.MouseEvent<HTMLSpanElement>,
    data?: IIDCReading
  ) => {
    setState({
      ...state,
      manageActionsCallout: {
        isOpen,
        element: isOpen ? ele?.currentTarget : undefined,
        data,
      },
    });
  };

  return (
    <React.Fragment>
      {state.isLoading && <Loading />}
      {state.isDatacenterFound ? (
        <React.Fragment>
          <Stack>
            <Stack.Item>
              {/* <Text variant="xLarge">
                  IDC Temperature Readings -{" "}
                  {state.datacenter && state.datacenter.name}{" "}
                  {state.datacenter && state.datacenter.location && " - "}
                  {state.datacenter && state.datacenter.location}
                </Text> */}
              <Breadcrumb
                items={[
                  {
                    text: state.datacenter
                      ? state.datacenter.name
                      : "Datacenter",
                    key: "datacenter",
                  },
                  {
                    text: "Infrastructures",
                    key: "infrastructure",
                    onClick: () => {
                      history.goBack();
                    },
                  },
                  {
                    text: "IDC Temperature Readings",
                    key: "idc-temperature-readings",
                    isCurrentItem: true,
                  },
                ]}
              />
            </Stack.Item>
          </Stack>
          <br />
          <Stack horizontal horizontalAlign="start">
            <Stack.Item>
              <Stack horizontal wrap tokens={childrenGap}>
                <Stack.Item>
                  <Dropdown
                    placeholder="Select a Floor"
                    onRenderOption={onRenderOption}
                    onRenderTitle={onRenderTitle}
                    selectedKey={state.searchObj.floorId}
                    styles={{ dropdown: { width: 200 } }}
                    options={state.allFloorsDropdownList}
                    onChange={(e, v: IDropdownOption | undefined) => {
                      if (v) {
                        setState({
                          ...state,
                          searchObj: {
                            ...state.searchObj,
                            floorId: v.key as string,
                          },
                        });
                      }
                    }}
                  />
                </Stack.Item>
                <Stack.Item>
                  <DatePicker
                    firstDayOfWeek={DayOfWeek.Sunday}
                    showMonthPickerAsOverlay={true}
                    value={new Date(state.searchObj.date)}
                    showGoToToday={false}
                    onSelectDate={(date: Date | null | undefined) =>
                      setState({
                        ...state,
                        searchObj: { ...state.searchObj, date: date as Date },
                      })
                    }
                    placeholder="Select a date..."
                    ariaLabel="Select a date"
                    styles={{ root: { width: 200 } }}
                  />
                </Stack.Item>
                <Stack.Item>
                  <PrimaryButton text="Search" onClick={() => onSearch()} />
                </Stack.Item>
              </Stack>
            </Stack.Item>
            {/* <Stack.Item>
              <DefaultButton
                text="Accept"
                disabled={state.selectedItems.length === 0}
                onClick={() => handleAcceptOrRejectSelected(true)}
              />
              &nbsp;&nbsp;
              <DefaultButton
                text="Reject"
                disabled={state.selectedItems.length === 0}
                onClick={() => handleAcceptOrRejectSelected(false)}
              />
            </Stack.Item> */}
          </Stack>
          <br />
          <Stack horizontal horizontalAlign="space-between" wrap>
            <Stack.Item className="ml-6">
              <span
                onClick={
                  state.allFloorsDropdownList.length < 2 ||
                    state.allFloorsDropdownList[1]?.key ===
                    state.searchObj.floorId
                    ? undefined
                    : () => onNextOrPrevFunc(true)
                }
                className={
                  state.allFloorsDropdownList.length < 2 ||
                    state.allFloorsDropdownList[1]?.key ===
                    state.searchObj.floorId
                    ? "btn-disabled"
                    : "btn-enabled pointer"
                }
              >
                <Icon
                  path={mdiChevronLeft}
                  size={0.9}
                  className="btnIcon"
                  style={{
                    marginBottom: -6,
                    marginRight: -8,
                    color: BRAND_SECONDARY,
                  }}
                />
                <DefaultButton
                  text="Previous IDC"
                  className="borderless-btn"
                // disabled={
                //     state.allFloorsDropdownList[1].key ===
                //     state.searchObj.floorId
                //   }
                // onClick={() => {
                //   onNextOrPrevFunc(true);
                // }}
                />
              </span>
              <span className="nxt-prv-btn-border"></span>
              <span
                onClick={
                  state.allFloorsDropdownList.length < 2 ||
                    state.allFloorsDropdownList[
                      state.allFloorsDropdownList.length - 1
                    ]?.key === state.searchObj.floorId
                    ? undefined
                    : () => onNextOrPrevFunc(false)
                }
                className={
                  state.allFloorsDropdownList.length < 2 ||
                    state.allFloorsDropdownList[
                      state.allFloorsDropdownList.length - 1
                    ]?.key === state.searchObj.floorId
                    ? "btn-disabled"
                    : "btn-enabled pointer"
                }
              >
                <DefaultButton
                  text="Next IDC"
                  // disabled={
                  //   state.allFloorsDropdownList[
                  //     state.allFloorsDropdownList.length - 1
                  //   ].key === state.searchObj.floorId
                  // }
                  // onClick={() => {
                  //   onNextOrPrevFunc(false);
                  // }}
                  className="borderless-btn"
                />
                <Icon
                  path={mdiChevronRight}
                  size={0.9}
                  className="btnIcon"
                  style={{ marginBottom: -6, marginLeft: -8, color: BRAND_SECONDARY }}
                />
              </span>
            </Stack.Item>
            <Stack.Item>
              <DefaultButton
                text="Accept"
                className="mr-8 custom-secondary-btn"
                disabled={state.selectedItems.length === 0}
                onClick={() => handleAcceptOrRejectSelected(true)}
              />
              <DefaultButton
                text="Reject"
                disabled={state.selectedItems.length === 0}
                onClick={() => handleAcceptOrRejectSelected(false)}
                className="custom-secondary-btn"
              />
            </Stack.Item>
          </Stack>
          {/* <Stack horizontal horizontalAlign="end" wrap>
            <Stack.Item>
              <DefaultButton
                text="Accept"
                className="mr-8"
                disabled={state.selectedItems.length === 0}
                onClick={() => handleAcceptOrRejectSelected(true)}
              />
            </Stack.Item>
            <Stack.Item>
              <DefaultButton
                text="Reject"
                disabled={state.selectedItems.length === 0}
                onClick={() => handleAcceptOrRejectSelected(false)}
              />
            </Stack.Item>
          </Stack> */}
          <br />
          {state.isIdcLoaded && (
            <Stack>
              <div className="office-table bg-white">
                <table className="ms-Table bordered-table w-100">
                  <thead className="html-table-thead">
                    <tr style={{ height: 50 }}>
                      <th rowSpan={2}>
                        <Checkbox
                          //   indeterminate={state.isIndeterminate}
                          checked={state.isAllChecked}
                          onChange={(eve, checked) =>
                            onSelectAll(checked as boolean)
                          }
                        />
                      </th>
                      <th rowSpan={2}>Time (Hrs)</th>
                      <th rowSpan={2}>System</th>
                      {state.tempArray.length > 0 &&
                        state.tempArray.map((ele, index) => (
                          <React.Fragment key={"top-" + index}>
                            <th colSpan={2}> IDC-{ele + 1} </th>
                          </React.Fragment>
                        ))}
                      <th rowSpan={2}>Date</th>
                      <th rowSpan={2}>Shift Tech Sign</th>
                      <th rowSpan={2}>Status</th>
                      <th rowSpan={2}>Remarks</th>
                      <th rowSpan={2}>Read At</th>
                      <th rowSpan={2}>Actions</th>
                    </tr>
                    <tr>
                      {state.tempArray.length > 0 &&
                        state.tempArray.map((ele, index) => (
                          <React.Fragment key={"top2-" + index}>
                            <th> Temp ℃ </th>
                            <th> RH (%) </th>
                          </React.Fragment>
                        ))}
                    </tr>
                  </thead>
                  <tbody>
                    {EVEN_SHIFT.map((ele, index) => {
                      let item = state.idcReading.find(
                        (e) => e.shiftTime === ele
                      );
                      return (
                        <tr key={index}>
                          <th>
                            <Checkbox
                              disabled={!item || item.status !== "submitted"}
                              checked={state.selectedItems.includes(
                                item?._id as string
                              )}
                              onChange={() =>
                                onIndividualSelect(item?._id as string)
                              }
                              className="ml-12"
                            />
                          </th>
                          <th> {ele} </th>
                          <td>
                            {item?.isSystemOn !== undefined
                              ? item?.isSystemOn === true
                                ? "On"
                                : "Off"
                              : ""}
                          </td>
                          {state.tempArray.length > 0 &&
                            state.tempArray.map((ele, i) => (
                              <React.Fragment key={"bottom-" + i}>
                                <td
                                  className={
                                    isInThreshold(
                                      item?.readings?.[ele]?.temp || "",
                                      "temp",
                                      state.threshold
                                    )
                                      ? "text-danger"
                                      : ""
                                  }
                                >
                                  {item?.readings?.[ele]?.temp || ""}
                                  {isInThreshold(
                                    item?.readings?.[ele]?.temp || "",
                                    "temp",
                                    state.threshold
                                  ) && (
                                      <ShowThresholdIcon
                                        isLessThan={
                                          isValueLessThanThreshold(
                                            item?.readings?.[ele]?.temp || "",
                                            "temp",
                                            state.threshold
                                          ) as boolean
                                        }
                                      />
                                    )}
                                </td>
                                <td
                                  className={
                                    isInThreshold(
                                      item?.readings?.[ele]?.rh || "",
                                      "rh",
                                      state.threshold
                                    )
                                      ? "text-danger"
                                      : ""
                                  }
                                >
                                  {item?.readings?.[ele]?.rh || ""}
                                  {isInThreshold(
                                    item?.readings?.[ele]?.rh || "",
                                    "rh",
                                    state.threshold
                                  ) && (
                                      <ShowThresholdIcon
                                        isLessThan={
                                          isValueLessThanThreshold(
                                            item?.readings?.[ele]?.rh || "",
                                            "rh",
                                            state.threshold
                                          ) as boolean
                                        }
                                      />
                                    )}
                                </td>
                              </React.Fragment>
                            ))}
                          <td>
                            {" "}
                            {item?.date
                              ? moment(item.date).format("DD-MM-YYYY")
                              : ""}{" "}
                          </td>
                          <td>{item?.recordedBy || ""}</td>
                          <td>
                            {item && item.status ? UPS_STATUS[item.status] : ""}
                          </td>
                          <td>{item?.remarks || ""}</td>
                          <td>
                            {item?.date
                              ? moment(item.date).format(READ_AT_TIME_FORMAT)
                              : ""}
                          </td>
                          <td align="center" className="no-wrap">
                            {item && item.status === "submitted" && (
                              <span
                                onClick={(ele) =>
                                  handleCallOutOpenClose(true, ele, item)
                                }
                              >
                                <Icon
                                  path={mdiDotsVertical}
                                  size={0.9}
                                  className="pointer"
                                  color={BRAND_SECONDARY}
                                />
                              </span>
                              // <React.Fragment>
                              //   <TooltipHost
                              //     content="Update"
                              //     calloutProps={{ gapSpace: 0 }}
                              //   >
                              //     <span
                              //       onClick={() =>
                              //         handleOpenDialog(true, item?._id)
                              //       }
                              //     >
                              //       <Icon
                              //         path={mdiPencil}
                              //         size={0.7}
                              //         className="pointer"
                              //       />
                              //     </span>
                              //   </TooltipHost>
                              //   &nbsp;&nbsp;
                              //   <TooltipHost
                              //     content="Accept"
                              //     calloutProps={{ gapSpace: 0 }}
                              //   >
                              //     <span
                              //       onClick={() =>
                              //         handleAcceptOrReject(
                              //           item?._id as string,
                              //           true
                              //         )
                              //       }
                              //     >
                              //       <Icon
                              //         path={mdiCheck}
                              //         size={0.8}
                              //         className="pointer"
                              //         color="green"
                              //       />
                              //     </span>
                              //   </TooltipHost>
                              //   &nbsp;&nbsp;
                              //   <TooltipHost
                              //     content="Reject"
                              //     calloutProps={{ gapSpace: 0 }}
                              //   >
                              //     <span
                              //       onClick={() =>
                              //         handleRejectOpenDialog(
                              //           item?._id as string,
                              //           item?.remarks
                              //         )
                              //       }
                              //     >
                              //       <Icon
                              //         path={mdiClose}
                              //         size={0.8}
                              //         className="pointer"
                              //         color="red"
                              //       />
                              //     </span>
                              //   </TooltipHost>
                              // </React.Fragment>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                    <tr>
                      <td></td>
                      <th>Min Value</th>
                      <td></td>
                      {state.tempArray.length > 0 &&
                        state.tempArray.map((ele, i) => (
                          <React.Fragment key={"bottom-3" + i}>
                            <td> {getMinValue("temp", i)} </td>
                            <td> {getMinValue("rh", i)} </td>
                          </React.Fragment>
                        ))}
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <th>Max Value</th>
                      <td></td>
                      {state.tempArray.length > 0 &&
                        state.tempArray.map((ele, i) => (
                          <React.Fragment key={"bottom-4" + i}>
                            <td> {getMaxValue("temp", i)} </td>
                            <td> {getMaxValue("rh", i)} </td>
                          </React.Fragment>
                        ))}
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              {/* <div className="next-prev-btn">
                <div>
                  <DefaultButton
                    text="Previous IDC"
                    className="mr-8"
                    disabled={
                      state.allFloorsDropdownList[1].key ===
                      state.searchObj.floorId
                    }
                    onClick={() => {
                      onNextOrPrevFunc(true);
                    }}
                  />
                  <DefaultButton
                    text="Next IDC"
                    disabled={
                      state.allFloorsDropdownList[
                        state.allFloorsDropdownList.length - 1
                      ].key === state.searchObj.floorId
                    }
                    onClick={() => {
                      onNextOrPrevFunc(false);
                    }}
                  />
                </div>
              </div> */}
            </Stack>
          )}
        </React.Fragment>
      ) : (
        <NoDataTile
          title="No Datacenter Found"
          description="Datacenter either deleted or not created"
        />
      )}
      {state.manageActionsCallout.isOpen && (
        <Callout
          styles={{ root: { width: 95, padding: 20 } }}
          role="alertdialog"
          ariaLabelledBy={
            state.manageActionsCallout && state.manageActionsCallout.data?._id
          }
          gapSpace={0}
          target={state.manageActionsCallout.element}
          directionalHint={DirectionalHint.leftCenter}
          onDismiss={() => handleCallOutOpenClose(false)}
        // setInitialFocus={true}
        >
          <Stack tokens={childrenGap8}>
            <Stack.Item className="pointer">
              <span
                onClick={() =>
                  handleOpenDialog(
                    true,
                    state.manageActionsCallout.data?._id as string
                  )
                }
                className="callout-options"
              >
                Edit
              </span>
            </Stack.Item>
            <Stack.Item className="pointer">
              <span
                onClick={() =>
                  handleAcceptOrReject(
                    state.manageActionsCallout.data?._id as string,
                    true
                  )
                }
                className="callout-options"
              >
                Accept
              </span>
            </Stack.Item>
            <Stack.Item className="pointer">
              <span
                onClick={() =>
                  handleRejectOpenDialog(
                    state.manageActionsCallout.data?._id as string,
                    state.manageActionsCallout.data?.remarks
                  )
                }
                className="callout-options"
              >
                Reject
              </span>
            </Stack.Item>
          </Stack>
        </Callout>
      )}
      {state.manageIdcDialog.isOpen && (
        <ManageIdcTemperatureDialog
          closeManageDialog={(data: IIDCReading) => handleCloseDialog(data)}
          data={state.manageIdcDialog.data}
          handleLoading={handleLoading}
          threshold={state.threshold}
        />
      )}
      {state.manageRejectDialog.isOpen && (
        <ManageAllRejectDialog
          handleRejectCloseDialog={(isSuccess: boolean, remarks?: string) =>
            handleRejectCloseDialog(isSuccess, remarks)
          }
          remarks={state.manageRejectDialog.remarks}
          subText="idc reading"
        />
      )}
    </React.Fragment>
  );
};

export default IdcTemperatureMain;
